import { render, staticRenderFns } from "./TemplateDetail.vue?vue&type=template&id=a9306c5e&scoped=true&"
import script from "./TemplateDetail.vue?vue&type=script&lang=ts&"
export * from "./TemplateDetail.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateDetail.vue?vue&type=style&index=0&id=a9306c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9306c5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextField,VTextarea})
